import React from 'react';
import Header from '../../components/ui/Header';
import Footer from '../homepage/components/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesGrid from './components/ServicesGrid';
import WhyChooseUs from './components/WhyChooseUs';

const Services = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      {/* Main Content */}
      <main className="pt-16 lg:pt-18">
        <ServicesHero />
        <ServicesGrid />
        <WhyChooseUs />
      </main>
      
      <Footer />
    </div>
  );
};

export default Services;
